export { default } from './CardCoordinateMerchant';
